import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import Home from "@/pages/Home";
import CategoryPage from "@/pages/CategoryPage";
import ProductDetail from "@/pages/ProductDetail";
import SearchPage from "@/pages/SearchPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AddProduct from "@/pages/AddProduct";
import ManageProducts from "@/pages/ManageProducts";
import ManageCategories from "@/pages/ManageCategories";
import AdminSettings from "@/pages/AdminSettings";
import Broadcast from "@/pages/Broadcast";
import ShopQR from "@/pages/ShopQR";
import Inventory from "@/pages/Inventory";
import BulkUpload from "@/pages/BulkUpload";
import Drafts from "@/pages/Drafts";
import ManageStaff from "@/pages/ManageStaff";
import PublicProduct from "@/pages/PublicProduct";
import PublicCategory from "@/pages/PublicCategory";

const Private = ({ children }) => {
  const { isAuthed } = useAuth();
  if (!isAuthed) return <Navigate to="/admin/login" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/category/:id" element={<CategoryPage />} />
            <Route path="/product/:id" element={<ProductDetail />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Private><AdminDashboard /></Private>} />
            <Route path="/admin/add" element={<Private><AddProduct /></Private>} />
            <Route path="/admin/products" element={<Private><ManageProducts /></Private>} />
            <Route path="/admin/products/:id" element={<Private><AddProduct /></Private>} />
            <Route path="/admin/categories" element={<Private><ManageCategories /></Private>} />
            <Route path="/admin/settings" element={<Private><AdminSettings /></Private>} />
            <Route path="/admin/broadcast" element={<Private><Broadcast /></Private>} />
            <Route path="/admin/qr" element={<Private><ShopQR /></Private>} />
            <Route path="/admin/inventory" element={<Private><Inventory /></Private>} />
            <Route path="/admin/bulk-upload" element={<Private><BulkUpload /></Private>} />
            <Route path="/admin/drafts" element={<Private><Drafts /></Private>} />
            <Route path="/admin/staff" element={<Private><ManageStaff /></Private>} />
            <Route path="/p/:slug" element={<PublicProduct />} />
            <Route path="/c/:slug" element={<PublicCategory />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </AuthProvider>
  );
}

export default App;
